"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  height: 458px;\n  z-index: -1;\n  border-bottom-left-radius: 100%;\n  border-bottom-right-radius: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledBlob = _styledComponents.default.div.withConfig({
  displayName: "StyledBlob",
  componentId: "sc-19esj0s-0"
})(_templateObject(), _colors.GYPSUM);

var _default = StyledBlob;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/StyledBlob.js
// module id = 206
// module chunks = 5 6